export default "__VITE_ASSET__pYcSBZBs__"